import * as React from "react";
import type { SVGProps } from "react";

const ArrowIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = "1em",
  height = "1em",
  fill = "none",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 9"
    width={width}
    height={height}
    fill={fill}
    {...props}
  >
    <path d="M0.293 0.723L6.79 8.723L13.293 0.723H0.293Z" fill={props.color || "#127035"} />
  </svg>
);

export default ArrowIcon;
